"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractFailure = void 0;
class AbstractFailure {
    constructor(message) {
        this.message = message;
    }
}
exports.AbstractFailure = AbstractFailure;
